import { Message } from 'element-ui';
export default {
    install(Vue) {
        Vue.prototype.$validForm = (arr) => {
            const index = arr.findIndex((item)=>{
                return item.case === true
            })
            if  (index !== -1) {
                Message.error({
                    message: arr[index].message
                })
                return false;
            } else {
                return true
            }
        }
    }
}